import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AppConstants} from '../shared/app.constants';
import {Observable} from 'rxjs/Observable';
import {AuthService} from '../auth.service';

@Injectable()
export class StatisticsService {

  constructor(private http: HttpClient, private appConstants: AppConstants, private auth: AuthService) {
  }

  fetchStats(body = {}): Observable<any> {
    const url = environment.apiBase + 'stats';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

  fetchHours(body): Observable<any> {
    const url = environment.apiBase + 'hours/';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(response => response).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/statistics.service.ts